import { z } from 'zod';
import type { TFunction } from 'i18next';
import type { FormParam } from './types';
import { createWithdrawAmountSchema } from '@/entities/operation';

export const createWithdrawBankTransferSchema = (
  t: TFunction,
  params: FormParam[],
  isDisplayAmount: boolean,
  maxAvailable: number,
  minWithdraw?: number,
  totalAmount?: number,
  maxWithdraw?: number,
  maxWithdrawMessage?: string
) => {
  const requiredMessage = t('common.requiredField');
  const schemaFields: Record<string, z.ZodTypeAny> = {};

  if (isDisplayAmount) {
    schemaFields.amount = createWithdrawAmountSchema({
      minWithdraw,
      maxAvailable,
      totalAmount,
      maxWithdraw,
      maxWithdrawMessage,
    });

    schemaFields.includeFee = z.boolean().default(false);
  }

  params.forEach(param => {
    if (param.isRequired) {
      schemaFields[param.paramId] = z
        .string({ message: requiredMessage })
        .nonempty({ message: requiredMessage });
    } else {
      schemaFields[param.paramId] = z.string().optional();
    }
  });

  return z.object(schemaFields);
};
